<template>
    <div>Настройки форума</div>
</template>

<script>
    export default {
        name: "Profile-user"
    }
</script>

<style scoped>

</style>
